// TODO all config keys must be in uppercase
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'tripstracker'
export const NOT_AVAILABLE = process.env.REACT_APP_NOT_AVAILABLE || 'N/A'

export const MODULES = {
  dashboard: {
    active: true,
    permissions: {}
  },
  vehicles: {
    active: true,
    permissions: {}
  },
  trips: {
    active: true,
    permissions: {}
  },
  devices: {
    active: true,
    permissions: {}
  }
}

export const ROUTES = {
  base: '/',
  auth: '/login',
  dashboard: '/dashboard',
  vehicles: '/veicoli',
  createVehicle: '/veicolo/crea',
  editVehicle: '/veicolo/modifica/',
  devices: '/dispositivi',
  createDevice: '/dispositivo/crea',
  editDevice: '/dispositivo/modifica/',
  vehicleTrips: '/viaggi/veicolo/',
  trips: '/viaggi',
  tripDetail: '/viaggio/',
  tripInProgress: '/realtime/'
}

export const BASE_MEDIA_QUERY = window.matchMedia('(min-width: 992px)')

export const HOME = {
  icon: 'pi pi-home',
  url: ROUTES.dashboard
}

// TODO label must be configured in Messages
export const BREAD_CRUMB_ITEMS = {
  dashboard: [
    { label: 'Dashboard' }
  ],
  deviceList: [
    { label: 'Gestione Dispositivi' }
  ],
  deviceCreate: [
    { label: 'Gestione Dispositivi', url: ROUTES.devices },
    { label: 'Crea nuovo dispositivo' }
  ],
  deviceEdit: [
    { label: 'Gestione Dispositivi', url: ROUTES.devices },
    { label: 'Modifica dispositivo' }
  ],
  vehicleList: [
    { label: 'Gestione veicoli' }
  ],
  vehicleCreate: [
    { label: 'Gestione veicoli', url: ROUTES.vehicles },
    { label: 'Crea nuovo veicolo' }
  ],
  vehicleEdit: [
    { label: 'Gestione veicoli', url: ROUTES.vehicles },
    { label: 'Modifica veicolo' }
  ],
  tripProgress: [
    { label: 'Viaggio in corso' }
  ],
  tripList: [
    { label: 'Gestione Viaggi' }
  ],
  tripDetail: [
    { label: 'Gestione Viaggi', url: ROUTES.tripDetail },
    { label: 'Dettaglio Viaggio' }
  ],
  vehicleTripList: [
    { label: 'Gestione Veicoli', url: ROUTES.vehicles },
    { label: 'Dettaglio viaggi veicolo' }
  ]
}

export const tooltipOptions = {
  position: 'top',
  showDelay: 700
}

export const formControllerStyle = {
  fontWeight: 'bold',
  marginBottom: '15px',
  display: 'block'
}

export const tableScrollHeight = '400px'
export const DEFAULT_DATE_FORMAT = process.env.DEFAULT_DATE_FORMAT || 'DD/MM/YYYY'
export const DEFAULT_TIME_FORMAT = process.env.DEFAULT_TIME_FORMAT || 'HH:mm'
export const DEFAULT_DATETIME_FORMAT = process.env.DEFAULT_DATETIME_FORMAT || `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`

export const GMAP_OPTIONS = {
  center: {
    lat: parseFloat(process.env.REACT_APP_MAP_CENTER_LAT || 0),
    lng: parseFloat(process.env.REACT_APP_MAP_CENTER_LON || 0)
  },
  zoom: parseFloat(process.env.REACT_APP_MAP_ZOOM || 10),
  style: {
    width: '100%',
    height: '650px'
  },
  marker: {
    size: [60, 60]
  },
  polylineStyle: {
    strokeOpacity: 0.7,
    strokeWeight: 14,
    geodesic: true
  },
  polylineDefault: '#46b363',
  polylineRed: '#eb5549',
  polylineDarkRed: '#a32e25',
  polylineYellow: '#fbc21e',
  polylineDarkYellow: '#af8304',
  gmapScriptId: 'googleMaps',
  gmapBaseUrl: 'https://maps.google.com/maps',
  overlayTypes: { events: 1 },
  minSegmentLen: 10
}

/* eslint-disable */
export const SegmentsThresholds = {
  LOW:      { minValue:  0, threshold: 10 },
  MID_LOW:  { minValue: 10, threshold: 30 },
  MID:      { minValue: 30, threshold: 60 },
  MID_HIGH: { minValue: 60, threshold: 90 },
  HIGH:     { minValue: 90, threshold: Number.MAX_VALUE }
}
/* eslint-enable */

export const DATA_TYPES = {
  raw: {
    text: 'Reale',
    value: 'raw'
  },
  snap: {
    text: 'Adattato',
    value: 'snap'
  },
  decode: (dataType) => {
    switch (dataType) {
      case DATA_TYPES.snap.text:
        return DATA_TYPES.snap.value
      case DATA_TYPES.raw.text:
        return DATA_TYPES.raw.value
      default:
        return DATA_TYPES.raw.value
    }
  }
}

export const FooterDetail = {
  company: process.env.REACT_APP_COMPANY_PRODUCTOR,
  piva: process.env.REACT_APP_PIVA,
  year: process.env.REACT_APP_YEAR,
  link: process.env.REACT_APP_LINK,
  version: process.env.REACT_APP_VERSION
}

export const FileManager = {
  fileSize: process.env.REACT_APP_VEHICLE_FILE_UPLOAD_MAX_SIZE || 1000000 // 1MB
}

export const LOCALE = {
  locale: 'it',
  options: {
    passwordPrompt: 'Inserisci password',
    firstDayOfWeek: 1,
    dayNames: [
      'domenica',
      'lunedì',
      'martedì',
      'mercoledì',
      'giovedì',
      'venerdì',
      'sabato'
    ],
    dayNamesShort: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
    monthNames: [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre'
    ],
    monthNamesShort: [
      'gen',
      'feb',
      'mar',
      'apr',
      'mag',
      'giu',
      'lug',
      'ago',
      'set',
      'ott',
      'nov',
      'dic'
    ],
    today: 'OGGI',
    clear: 'PULISCI'
  }
}

export const EVENT_TYPES = {
  TOWING: 246,
  CRASH: 247,
  IDLING: 251,
  SPEEDING: 255,
  HARD: 253,
  VIN: 256
}
